import { createTheme } from '@mui/material/styles'
import { themeOptions } from '@wolfdanepug/common-react'

export default createTheme({
	...themeOptions,
	poppins: 'Poppins, serif',
	monoton: 'Monoton, serif',
	typography: {
		...themeOptions.typography,
		fontFamily: 'Poppins, serif'
	}
})
